import generateBaseQuery from './base-query-generator';

const baseQuery = generateBaseQuery(process.env.ENTIER_BE_API + process.env.BE_API_VERSION);

export default baseQuery;
